import { render } from 'preact';

import { App } from './App';
import { createConfiguredPilotBackendClient } from './backend-client';
import { createConfiguredSupabaseSnapshotClient } from './supabase-client';
import './index.css';

const root = document.getElementById('app');
if (!root) {
  throw new Error('Root element #app not found');
}

const backendClient = createConfiguredPilotBackendClient();
const supabaseClient = createConfiguredSupabaseSnapshotClient();

// Auto-run the staging pipeline only when embedded in Forma's iframe, so the
// standalone preview stays idle (it has no live Forma connection).
const embeddedInForma = typeof window !== 'undefined' && window.self !== window.top;

render(
  <App
    autoRun={embeddedInForma}
    {...(backendClient === undefined ? {} : { backendClient })}
    {...(supabaseClient === undefined ? {} : { supabaseClient })}
  />,
  root,
);
